export default __webpack_public_path__ + "pbslm-logo-white.svg";